import { render } from "./ModalGraficoSprints.vue?vue&type=template&id=c4452d1c"
import script from "./ModalGraficoSprints.vue?vue&type=script&lang=js"
export * from "./ModalGraficoSprints.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__